import { Logo, LogoNameType, useColorScheme, useLanguage } from "@/lib/main";
import { CSSProperties, ReactNode } from "react";
import { NavLink } from "react-router";

type Props = {
  addNavbarLogo?: boolean;
  customNavbarLogo?: ReactNode;
  setIsDrawerOpen: (isOpen: boolean) => void;
  to?: string;
};

export default function NavbarLogo({
  addNavbarLogo,
  customNavbarLogo,
  setIsDrawerOpen,
  to,
}: Props) {
  const { colorScheme } = useColorScheme();
  const { language } = useLanguage();

  const getLogoName = (): LogoNameType => {
    switch (colorScheme) {
      case "light":
        return language === "ar" ? "blue-ar" : "blue";
      case "dark":
        return language === "ar" ? "white-ar" : "white";
      default:
        return "blue";
    }
  };

  const styles: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "var(--spacing-sm)",

    height: "var(--navbar-height)",
    paddingInlineEnd: "var(--spacing-md)",
  };

  return (
    <NavLink
      aria-label={
        language === "en" ? "Go to homepage" : "الذهاب إلى الصفحة الرئيسية"
      }
      onClick={() => {
        setIsDrawerOpen(false);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      style={styles}
      title={language === "en" ? "Home" : "الرئيسة"}
      to={to ? to : "/"}
    >
      {customNavbarLogo ? (
        customNavbarLogo
      ) : addNavbarLogo ? (
        <Logo name={getLogoName()} size="sm"></Logo>
      ) : null}
    </NavLink>
  );
}
